import { render } from "./TableTree.vue?vue&type=template&id=8c685406&scoped=true&ts=true"
import script from "./TableTree.vue?vue&type=script&lang=ts"
export * from "./TableTree.vue?vue&type=script&lang=ts"

import "./TableTree.vue?vue&type=style&index=0&id=8c685406&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c685406"]])

export default __exports__